import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Link2, Unlink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { GoogleAuthButton, useAuthConfig } from './GoogleAuthButton';
import { postJson } from '../../lib/authFlows';
import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';

// Ayarlar sayfasında mevcut hesabı bir Google hesabına bağlama
export const GoogleLinkCard = ({ apiBase, token }) => {
  const cfg = useAuthConfig(apiBase);
  const [me, setMe] = useState(null);

  const load = () => fetch(`${RUNTIME_BACKEND_URL}${apiBase}/me`, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.json()).then(setMe).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (token) load(); }, [token]);

  if (!cfg?.client_id || !me) return null;

  const link = (credential) => postJson(`${apiBase}/google/link`, { credential }, token)
    .then(d => { toast.success(`Google hesabı bağlandı: ${d.google_email}`); load(); })
    .catch(e => toast.error(e.message));

  const unlink = () => fetch(`${RUNTIME_BACKEND_URL}${apiBase}/google/link`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } })
    .then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); toast.success('Google bağlantısı kaldırıldı'); load(); })
    .catch(e => toast.error(e.message));

  return (
    <Card data-testid="google-link-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Link2 className="h-4 w-4" /> Google ile Giriş</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        {me.google_email ? (
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p>Bağlı Google hesabı: <b data-testid="google-linked-email">{me.google_email}</b></p>
            <Button variant="outline" size="sm" onClick={unlink} data-testid="google-unlink-btn"><Unlink className="h-3.5 w-3.5 mr-1.5" /> Bağlantıyı Kaldır</Button>
          </div>
        ) : (
          <>
            <p className="text-muted-foreground">Hesabınızı Google hesabınıza bağlayın; tüm verileriniz korunur ve bir sonraki girişte tek tıkla girebilirsiniz.</p>
            <GoogleAuthButton apiBase={apiBase} onCredential={link} text="continue_with" testId="google-link-btn" />
          </>
        )}
        {!me.has_password && <p className="text-xs text-amber-600">Hesabınızın şifresi yok. Şifre ile de girmek isterseniz giriş ekranındaki "Şifremi unuttum" ile şifre belirleyebilirsiniz.</p>}
      </CardContent>
    </Card>
  );
};
